<template>
  <div v-if="exchangeBoxVariants?.length > 1">
    <div v-if="isLoading" class="absolute inset-0 z-10 flex items-center justify-end bg-white/75" />

    <Paragraph class="text-lg font-medium xl:text-xl">
      <CommonLabel path="BWF/shop/productDetailPage/exchangeBox/configuratorHeadline" />
    </Paragraph>
    <Paragraph class="mt-6 text-lg font-medium xl:text-xl">
      <CommonLabel path="BWF/shop/productDetailPage/exchangeBox/cylinderHeadline" />
    </Paragraph>
    <Paragraph class="mt-2 text-lg xl:text-xl">
      <CommonLabel path="BWF/shop/productDetailPage/exchangeBox/cylinderQuestion" />
    </Paragraph>
    <Paragraph class="mt-2 text-sm">
      <Tint
        ><CommonLabel path="BWF/shop/productDetailPage/exchangeBox/cylinderQuestionHint"
      /></Tint>
    </Paragraph>

    <fieldset class="mt-4">
      <SelectField
        v-model="selectedOption"
        :options="selectableOptions"
        class="w-full"
        label="Anzahl Zylinder zuhause"
      />
    </fieldset>
  </div>
</template>

<script setup>
import { Paragraph } from "~/components/clarity-ui/Paragraph";
import { Tint } from "~/components/clarity-ui/Tint";
import { useExchangeBox } from "~/composables/shop/useExchangeBoxProduct";
import CommonLabel from "~/templates/components/CommonLabel.vue";
import SelectField from "~/templates/elements/form/SelectField.vue";

const emit = defineEmits(["change", "beforeChange"]);
const isLoading = ref(false);

const { product } = useProduct();

const { exchangeBoxVariants, maxAmount } = await useExchangeBox();

const selectedOption = ref(product.value.id);

const selectableOptions = computed(() =>
  exchangeBoxVariants.value?.map?.((option) => ({
    value: option.id,
    label: 1 + (maxAmount.value - parseInt(option.customFields["contract_amount_cylinders"])),
  })),
);

watch(selectedOption, () => {
  emit("beforeChange");
  const selectedVariant = exchangeBoxVariants.value?.find(
    (variant) => variant.id === selectedOption.value,
  );
  emit("change", selectedVariant);
});
</script>
